module.exports = __webpack_public_path__ + "static/media/facebook-grey.25316967.svg";